<template>
  <div class="image">
    <FileLimitDesc v-if="withDesc" v-bind="imageInfo">
      <!--  <template slot="btn">
        <el-button type="primary" @click="$emit('upload', 'image')">选择图片</el-button>
      </template> -->

      <p>横版大图：宽高比1.78，最低尺寸1280&times;720</p>
      <p>竖版图片：宽高比0.56，最低尺寸720&times;1280</p>
      <p>支持JPG、PNG等图片格式，大小500K以下</p>
    </FileLimitDesc>
    <el-tag class="badge">{{ badge }}{{ index + 1 }}</el-tag>
    <img loading="lazy" :class="height >= width ? 'h-full' : 'w-full'" v-if="$attrs.preview_url" :src="$attrs.preview_url" alt="" />

    <i v-if="removeable" class="remove el-icon-error" @click="$emit('remove')"></i>
    <!-- <p class="material-name" :title="$attrs.name">{{ $attrs.name }}</p> -->
    <div class="asset-name">
      <p v-if="width">
        <el-tag type="info">{{ width }}&times;{{ height }}</el-tag>
      </p>
      <p v-if="$attrs.size">
        <el-tag type="info">{{ ($attrs.size / 1024 / 1024).toFixed(2) }}M</el-tag>
      </p>
      <p>
        <el-tag type="info">{{ $attrs.name }}</el-tag>
      </p>
    </div>
  </div>
</template>

<script>
import FileLimitDesc from './material-desc.vue'
export default {
  components: { FileLimitDesc },
  props: {
    badge: {
      type: String,
      default: '图片'
    },
    width: {
      type: Number
    },
    height: {
      type: Number
    },
    index: {
      type: Number
    },
    // 是否显示描述和关闭按钮，默认显示
    withDesc: {
      type: Boolean,
      default: true
    },
    removeable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  computed: {
    imageInfo() {
      return {
        description: '图片',
        width: this.width,
        height: this.height,
        file_size: 1024 * 1,
        file_format: ['JPG', 'PNG']
      }
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
@import './styles.scss';
.image {
  min-width: 284.4444px;
}
.h-full {
  height: 100%;
}
.w-full {
  width: 100%;
}
</style>
